<template>
	<el-tabs type="border-card">
		<el-tab-pane label="商城设置">
			<el-form>
				<el-form-item label="商城名称" label-width="180px">
					<el-input></el-input>
				</el-form-item>
				<el-form-item label="商城LOGO" label-width="180px">
					<Shangwenjian v-model="n1" anniu="选择图片" :leixing="tu">
					</Shangwenjian>
				</el-form-item>
				<el-form-item label="客服电话" label-width="180px">
					<el-input></el-input>
				</el-form-item>
				<el-form-item label="拼团规则" label-width="180px">
					<Bianjiqi style="margin-left:28px;"></Bianjiqi>
				</el-form-item>
				<el-form-item label="砍价规则" label-width="180px">
					<Bianjiqi style="margin-left: 28px;"></Bianjiqi>
				</el-form-item>
				<el-form-item label-width="210px">
					<Tijiao @click="Tijiao" wenzi="提交" type="danger"></Tijiao>
				</el-form-item>
			</el-form>
		</el-tab-pane>
		<el-tab-pane label="交易设置">
			<el-form>
				<el-form-item label="自动收货(天)" label-width="180px">
					<el-input v-model="input"></el-input>
					<span  class="tishi">多少天自动收货</span>
				</el-form-item>
				<el-form-item label="积分折扣比例(倍)" label-width="180px">
					<el-input v-model="input2"></el-input>
					<span class="tishi">设置后1元等于多少个积分</span>
				</el-form-item>
				<el-form-item label="" label-width="210px">
					<Tijiao @click="Tijiao" wenzi="提交" type="danger"></Tijiao>
				</el-form-item>
			</el-form>
		</el-tab-pane>
	</el-tabs>

</template>

<script>
	import Bianjiqi from '../../zujian/Bianjiqi.vue'
	import Shangwenjian from '../../zujian/Shangwenjian.vue'
	let that;
	export default {
		data() {
			return {
				n1: '',
				tu:'',
				input:'',
				input2:''
			}
		},
		components: {
			Bianjiqi,
			Shangwenjian
		},

		methods: {
			Tijiao() {
				this.$post('k=peizhi&c=xiugai', that.shu, function(s) {
					that.$xiaoxi(s.shu);
					if (s.shi == 1) {
						that.CSH();
					}
				});
			},
		}
	}
</script>
</script>

<style>
	.el-input__inner {
		margin-left: 30px;
	}
	.tishi{
		margin-left:28px;display: block; color: #737373;
	}
</style>
